import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import verifyUserStoreModule from './verifyUserStore.js'
import verifyPhoneStoreModule from './verifyPhoneStore.js'
import { locationStoreModule } from './locationStore.js'
import { missingInfoStore } from './missingInfoStore.js'
import VueCryptojs from 'vue-cryptojs'
import { setItem, deleteItem } from '../utils/indexdb.js'
import features from './modules/features';

Vue.use(Vuex)
Vue.use(VueCryptojs)

export default new Vuex.Store({
	namespace: true,
	modules: {
		verifyUserStore: verifyUserStoreModule,
		locationStore: locationStoreModule,
		verifyPhoneStore: verifyPhoneStoreModule,
		missingInfoStore,
		features
	},
	state: {
		blockInitialPagesOnSignup: true,
		drawer: false,
		mini: true,
		token: '',
		refreshToken: '',
		id: '',
		name: '',
		email: '',
		country: null,
		isdCode: null,
		contact: null,
		qrCode: null,
		consultancyFees: null,
		user: {
			userName: '',
			password: ''
		},
		sectionInfo: null,
		prescription: [],
		profileImage: '',
		screenName: 'Dashboard',
		position: {
			lat: null,
			long: null
		},
		appVersion: null,
		userRegion: null,
		isSubscribe: null,
		AccessDataInDay: null,
		pageAccess: null,
		isOwner: null,
		NewUser: false,
		Dashboard: true,
		Patient: true,
		Treatment: true,
		Appointment: true,
		language: 'English'
	},
	plugins: [
		createPersistedState({
			paths: [
				'id',
				'token',
				'user',
				'name',
				'email',
				'country',
				'prescription',
				'profileImage',
				'isdCode',
				'appVersion',
				'userRegion',
				'isSubscribe',
				'AccessDataInDay',
				'pageAccess',
				'isOwner',
				'Dashboard',
				'Patient',
				'Treatment',
				'Appointment',
				'NewUser',
				'language'
			]
		})
	],
	mutations: {
		CLOSE_DRAWER(state) {
			state.drawer = false
			state.mini = true
		},
		toggleDrawer(state) {
			state.drawer = !state.drawer
		},
		toggleMini(state, paylod) {
			state.mini = paylod
		},
		setToken(state, token) {
			state.token = token
			if (token) setItem('token', token)
			else deleteItem('token')
		},
		setRefreshToken(state, refreshToken) {
			state.refreshToken = refreshToken
			if (refreshToken) setItem('refreshToken', refreshToken)
			else deleteItem('refreshToken')
		},
		setUserId(state, id) {
	state.id = id
	if (id) {
		setItem('userId', id)
		// Also set in localStorage directly for redundancy
		localStorage.setItem('userId', id)
	} else {
		deleteItem('userId')
		localStorage.removeItem('userId')
	}
},
		setUserName(state, name) {
			state.name = name
		},
		setUserEmail(state, email) {
			state.email = email
		},
		setUserCountry(state, country) {
			state.country = country
		},
		setUserIsd(state, isdCode) {
			state.isdCode = isdCode
		},
		setScreenName(state, screenName) {
			state.screenName = screenName
		},
		setUserBlank(state) {
			state.token = ''
			state.refreshToken = ''
			state.id = ''
			state.name = null
			state.email = null
			state.country = null
			state.isdCode = null
			state.profileImage = ''
			state.contact = null
			state.qrCode = null
			state.consultancyFees = null
			// state.language = 'English'
			deleteItem('userId')
			deleteItem('token')
			deleteItem('refreshToken')
		},
		setUser(state, user) {
			state.user = user
		},
		setPrescriptionList(state, prescription) {
			state.prescription = prescription
		},
		setProfileImage(state, image) {
			state.profileImage = image
		},
		setUserPosition(state, { lat, long }) {
			state.position.lat = lat
			state.position.long = long
		},
		setUserData(state, user) {
			state.name = user.name
			state.email = user.email
			state.country = user.country
			state.isdCode = user.isdCode
			state.profileImage = user.profileImage
			state.contact = user.contact
			state.qrCode = user.qrCode
			state.consultancyFees = user.consultancyFees
		},
		setSectionInfo(state, payload) {
			state.sectionInfo = payload
		},
		setAppVersion(state, appVersion) {
			state.appVersion = appVersion
			setItem('app-version', appVersion)
		},
		setUserRegion(state, region) {
			state.userRegion = region
		},
		setisSubscribe(state, isSubscribe) {
			state.isSubscribe = isSubscribe
		},
		setAccessDataInDay(state, AccessDataInDay) {
			state.AccessDataInDay = AccessDataInDay
		},
		setPageAccess(state, pageAccess) {
			state.pageAccess = pageAccess
		},
		setisOwner(state, isOwner) {
			state.isOwner = isOwner
		},
		setNewUser(state, value) {
			state.NewUser = value
		},
		setDashboard(state, value) {
			state.Dashboard = value
		},
		setPatient(state, value) {
			state.Patient = value
		},
		setTreatment(state, value) {
			state.Treatment = value
		},
		setAppointment(state, value) {
			state.Appointment = value
		},
		setLanguage(state, value) {
			state.language = value ? value : "English"
		},
		setBlockPagesFlag(state, value){
			state.blockInitialPagesOnSignup = value
		}
	},
	actions: {
		TOGGLE_DRAWER({ commit }) {
			commit('toggleDrawer')
		},
		TOGGLE_MINI({ commit }, paylod) {
			commit('toggleMini', paylod)
		},
		setUserRegion(state, region) {
			state.userRegion = region
		},
		setisSubscribe(state, isSubscribe) {
			state.isSubscribe = isSubscribe
		},
		setAccessDataInDay(state, AccessDataInDay) {
			state.AccessDataInDay = AccessDataInDay
		},
		setPageAccess(state, pageAccess) {
			state.pageAccess = pageAccess
		},
		setisOwner(state, isOwner) {
			state.isOwner = isOwner
		},
		setNewUser(state, value) {
			state.NewUser = value
		},
		setDashboard(state, value) {
			state.Dashboard = value
		},
		setPatient(state, value) {
			state.Patient = value
		},
		setTreatment(state, value) {
			state.Treatment = value
		},
		setAppointment(state, value) {
			state.Appointment = value
		},
		setLanguage(state, value) {
			state.language = value
		},

	},
	getters: {
		getBlockPagesFlag(state){
			return state.blockInitialPagesOnSignup
		},
		getUserRegion(state) {
			return state.userRegion
		},
        getContact(state) {
            return state.contact
        },
		getisSubscribe(state) {
			return state.isSubscribe
		},
		getAccessDataInDay(state) {
			return state.AccessDataInDay
		},
		getPageAccess(state) {
			return state.pageAccess
		},
		getisOwner(state) {
			return state.isOwner
		},
		DRAWER_STATE(state) {
			return state.drawer
		},
		getToken(state) {
			setItem('token', state.token)
			return state.token
		},
		getUserId: (state) => {
	// Try multiple sources in order of preference
	if (state.id) return state.id
	if (state.user?.id) return state.user.id
	if (state.user?.Id) return state.user.Id
	
	// Try to get from localStorage as fallback
	try {
		const storedId = localStorage.getItem('userId')
		if (storedId) {
			// If found in localStorage but not in state, restore it to state
			state.id = storedId
			return storedId
		}
	} catch (e) {
		console.error('Error accessing localStorage for userId:', e)
	}
	
	return null
},
		// getUserId: (state) => state.id || state.user?.id,
		getUserName(state) {
			return state.name
		},
		getUserEmail(state) {
			return state.email
		},
		getUserCountry(state) {
			return state.country
		},
		getUserIsd(state) {
			return state.isdCode
		},
		getUser(state) {
			return state.user
		},
		getRefreshToken(state) {
			return state.refreshToken
		},
		getPrescriptionList(state) {
			return state.prescription
		},
		getProfileImage(state) {
			return state.profileImage
		},
		getScreenName(state) {
			return state.screenName
		},
		getAppVersion(state) {
			return state.appVersion
		},
		getNewUser(state) {
			return state.NewUser
		},
		getDashboard(state) {
			return state.Dashboard
		},
		getPatient(state) {
			return state.Patient
		},
		getTreatment(state) {
			return state.Treatment
		},
		getAppointment(state) {
			return state.Appointment
		},
		getLanguage(state) {
			return state.language
		},
		getAuthToken: (state) => state.authToken
	}
})
